import React from 'react'
import { AnalysisContentProps } from './AnalysisContent.types'
import {
  ContentContainer,
  AnalysisSectionTitle,
  PlaceholderContent,
  PlaceholderIcon,
} from './AnalysisContent.styles'
import { Icon } from '../../atoms/Icon'

export const AnalysisContent: React.FC<AnalysisContentProps> = ({
  activeSection,
  sectionContent,
  placeholder = true,
  children,
  className,
}) => {
  const section =
    sectionContent[activeSection] || Object.values(sectionContent)[0]

  // If the section has a custom component, render it
  if (section.component) {
    return (
      <ContentContainer className={className}>
        {section.component}
      </ContentContainer>
    )
  }

  if (!placeholder && children) {
    return <ContentContainer className={className}>{children}</ContentContainer>
  }

  return (
    <ContentContainer className={className}>
      <AnalysisSectionTitle>{section.title}</AnalysisSectionTitle>
      {placeholder ? (
        <PlaceholderContent>
          <PlaceholderIcon>
            <Icon name={section.icon} size="xl" />
          </PlaceholderIcon>
          <div>
            <h3>{section.title} Content</h3>
            <p>
              This section will display detailed {section.title.toLowerCase()}{' '}
              information.
            </p>
          </div>
        </PlaceholderContent>
      ) : (
        children
      )}
    </ContentContainer>
  )
}

// Export styled components for custom styling if needed
export {
  ContentContainer,
  AnalysisSectionTitle,
  PlaceholderContent,
  PlaceholderIcon,
} from './AnalysisContent.styles'
